import { Observable } from 'rxjs';

import { AppType } from '../../../../types/enums/app/app-type.enum';
import { Platform } from '../../../../types/enums/platform/platform.enum';

/**ss
 * Interface for the version check request
 */
export interface VersionCheckRequest {
    app_type: AppType;
    platform: Platform;
    version: string;
}

/**
 * Interface for the version check response
 */
export interface VersionCheckResponse {
    requiresUpdate: boolean;
    minimumVersion: string;
}

export abstract class ActualAppVersionClient {
    /**
     * Makes an HTTP call to check if the app needs to be updated
     * @param request The version check request
     * @returns An Observable that emits true if the app needs to be updated, false otherwise
     */
    abstract checkVersion(request: VersionCheckRequest): Observable<boolean>;
}
